import { useEffect, useRef } from 'react';
import { initCanvasAnimation } from './lib/main';

import "./Resume.scss";

function Resume({ children }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    return initCanvasAnimation(canvasRef.current);
  }, []);

  return (
    <div className="resume">
      <canvas className="resume__canvas" ref={canvasRef} />
      {children}
    </div>
  );
}

export { Resume };
